module.exports = {
    title: 'Experiments',
    subtitle: 'A list of experiments',
};



// WEBPACK FOOTER //
// ./content/pages/experiments.js